<template>
  <div>
    <p v-if="isPlainText">
      {{ formattedString }}
    </p>
    <p
      v-else
      v-dompurify-html="formattedString ?? ''"
    />
    <span v-show="text && text.length > maxChars">
      <a
        id="readmore"
        :href="link"
        :class="moreTxtClass"
        @click="triggerReadMore($event, !isReadMore)"
      >
        {{ isReadMore ? lessStr : moreStr }}
      </a>
    </span>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

const props = defineProps({
  moreStr: {
    type: String,
    default: 'read more',
  },

  lessStr: {
    type: String,
    default: 'less',
  },

  moreTxtClass: {
    type: String,
    default: '',
  },

  text: {
    type: String,
    default: '',
  },

  link: {
    type: String,
    default: '#',
  },

  maxChars: {
    type: Number,
    default: 100,
  },

  isPlainText: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['expand']);

const isReadMore = ref(false);

const formattedString = computed(() => {
  if (!isReadMore.value && props.text && props.text.length > props.maxChars) {
    return props.text.substring(0, props.maxChars) + '...';
  }

  return props.text;
});

const triggerReadMore = (e: Event, flag: boolean) => {
  if (props.link == '#') {
    e.preventDefault();
  }

  if (props.lessStr) {
    isReadMore.value = flag;
  }

  emit('expand');
};
</script>
